import React, { useEffect, useState } from 'react';
import { Table, Card, Button, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import useApi from '../../Api';
import '../../styles/pages/Admin/FeedbackAdminPage.css';

let didInitialFetch = false;

const FeedbackAdminPage = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const apiClient = useApi();
  const limit = 10;

  useEffect(() => {
    const fetchFeedbacks = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get('/admin/feedback', {
          params: { limit, offset },
        });
        if (response.data.length < limit) {
          setHasMore(false);
        }
        setFeedbacks((prevFeedbacks) => [...prevFeedbacks, ...response.data]);
      } catch (error) {
        console.error('Error fetching feedback:', error);
      } finally {
        setLoading(false);
      }
    };

    if (offset === 0 && !didInitialFetch) {
      fetchFeedbacks();
      didInitialFetch = true;
    } else if (offset > 0) {
      fetchFeedbacks();
    }
  }, [apiClient, offset]);

  const handleLoadMore = () => {
    setOffset((prevOffset) => prevOffset + limit);
  };

  return (
    <>
      <Helmet>
        <title>WeiFinders Admin Feedback</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="feedback-admin-div">
        <Card className="feedback-admin-card">
          <Card.Body>
            <h2 className="feedback-admin-title">User Feedback</h2>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Feedback ID</th>
                  <th>User ID</th>
                  <th>Feedback</th>
                  <th>Submitted At</th>
                </tr>
              </thead>
              <tbody>
                {feedbacks.map((fb) => (
                  <tr key={fb.id}>
                    <td>{fb.id}</td>
                    <td>{fb.user_id}</td>
                    <td>{fb.feedback}</td>
                    <td>{new Date(fb.submitted_at).toLocaleString('en-GB')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {loading && (
              <div className="loading-spinner">
                <Spinner animation="border" variant="primary" />
              </div>
            )}
            {!loading && hasMore && (
              <Button variant="primary" onClick={handleLoadMore} className="load-more-button">
                Load More
              </Button>
            )}
            {!hasMore && (
              <p className="no-more-feedback">No more feedback to display.</p>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default FeedbackAdminPage;
